const CartesInfos = [
    {
        titre: "Produits d'exploitation",
        image: "prod",
        zoneId: 0,
        trueId: 0,
        corrections: [
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "Les ventes de services comme les prestations de dépannage ne sont pas des charges d'exploitation mais des produits d'exploitation. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les ventes de services comme les prestations de dépannage sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les ventes de services comme les prestations de dépannage sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les ventes de services comme les prestations de dépannage sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les ventes de services comme les prestations de dépannage sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            
        ],
        correct: "La valeur ajoutée est égale à la différence entre les produits d'exploitation, comme les ventes de prestations de dépannage, et les charges d'exploitation.",

    },
    {
        titre: "Achats de matières premières",
        image: "matieres",
        zoneId: 1,
        trueId: 1,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de matières premières ne sont pas des produits d'exploitation mais des charges d'exploitation. Retentez votre chance ! "
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de matières premières sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de matières premières sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de matières premières sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de matières premières sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },

            
        ],
        correct: "La valeur ajoutée est égale à la différence entre les produits d'exploitation et les charges d'exploitation, comme les achats de matières premières.",

    },
    {
        titre: "Achats de Marchandises",
        image: "marchandise",
        zoneId: 1,
        trueId: 2,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de marchandises ne sont pas des produits d'exploitation mais des charges d'exploitation. Retentez votre chance ! "
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de marchandises sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de marchandises sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de marchandises sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de marchandises sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
        ],
        correct: "La valeur ajoutée est égale à la différence entre les produits d'exploitation et les charges d'exploitation, comme les achats de marchandises.",

    },
    {
        titre: "Énergie",
        image: "energie",
        zoneId: 1,
        trueId: 3,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les dépenses de consommation d'énergie ne sont pas des produits d'exploitation mais des charges d'exploitation. Retentez votre chance ! "
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les dépenses de consommation d'énergie sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les dépenses de consommation d'énergie sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les dépenses de consommation d'énergie sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les dépenses de consommation d'énergie sont intégrées au calcul de la valeur ajoutée. Retentez votre chance !"
            },
        ],
        correct: "La valeur ajoutée est égale à la différence entre les produits d'exploitation et les charges d'exploitation, comme les dépenses de consommation d'énergie.",

    },
    {
        titre: "Sous-traitance",
        image: "sousTraitance",
        zoneId: 1,
        trueId: 4,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de sous-traitance ne sont pas des produits d'exploitation mais des charges d'exploitation. Retentez votre chance ! "
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de sous-traitance sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de sous-traitance sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de sous-traitance sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les achats de sous-traitance sont intégrés au calcul de la valeur ajoutée. Retentez votre chance !"
            },
        ],
        correct: "La valeur ajoutée est égale à la différence entre les produits d'exploitation et les charges d'exploitation, comme les achats de sous-traitance.",

    },
    {
        titre: "Salaires et cotisations sociales",
        image: "salaire",
        zoneId: 2,
        trueId: 5,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les salaires et cotisations sociales sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "Les salaires et cotisations sociales sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les salaires et cotisations sociales sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les salaires et cotisations sociales sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les salaires et cotisations sociales sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
           

        ],
        correct: "L'excédent brut d'exploitation est égal à la différence entre la valeur ajoutée, les charges de personnel (salaires et cotisations sociales) et les impôts et taxes.",

    },
    {
        titre: "Impôts et taxes",
        image: "impots",
        zoneId: 2,
        trueId: 6,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les impôts et taxes sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "Les impôts et taxes sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "Les impôts et taxes sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les impôts et taxes sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les impôts et taxes sont intégrés au calcul de l'excédent brut d'exploitation. Retentez votre chance !"
            },
            
        ],
        correct: "L'excédent brut d'exploitation est égal à la différence entre la valeur ajoutée, les charges de personnel (salaires et cotisations sociales) et les impôts et taxes.",

    },
    {
        titre: "Usure du temps",
        image: "usure",
        zoneId: 3,
        trueId: 7,
        // trueId2: 10,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: " Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps sont bien intégrées au calcul de la capacité d'autofinancement, mais sont des charges non décaissées et non des produits. Retentez votre chance !"
            },
           
        ],
        correct: "Le résultat d'exploitation est égal à la différence entre l'excédent brut d'exploitation et les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps.",
        correct2: "La capacité d'autofinancement est égale au résultat net majoré des charges non décaissées comme les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'usure du temps moins les produits nets de cessions d'actifs.",

    },
    {
        titre: "Obsolescence",
        image: "obsolescence",
        icon: "picto_banque",
        zoneId: 3,
        trueId: 8,
        // trueId2: 11,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence sont intégrées au calcul du résultat d'exploitation et de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "Les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence sont bien intégrées au calcul de la capacité d'autofinancement, mais sont des charges non décaissées et non des produits. Retentez votre chance !"
            },
            
        ],
        correct: "Le résultat d'exploitation est égal à la différence entre l'excédent brut d'exploitation et les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence.",
        correct2: "La capacité d'autofinancement est égale au résultat net majoré des charges non décaissées comme les dotations nettes aux amortissements qui représentent la perte de valeur d'une immobilisation due à l'obsolescence moins les produits nets de cessions d'actifs.",

    },
    {
        titre: "Résultat net (RN)",
        image: "resultat",
        icon: "picto_usure",
        zoneId: 4,
        trueId: 9,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "La somme du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés est intégrée au calcul du résultat net. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "La somme du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés est intégrée au calcul du résultat net. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "La somme du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés est intégrée au calcul du résultat net. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "La somme du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés est intégrée au calcul du résultat net. Retentez votre chance !"
            },
            {
                ids: [6],
                autoCorrect: false,
                presque: false,
                texte: "La somme du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés est intégrée au calcul du résultat net. Retentez votre chance !"
            },
           
        ],
        correct: "Le résultat net est égal à la somme du résultat d'exploitation, du résultat financier et du résultat exceptionnel moins l'impôt sur les sociétés.",

    },
    {
        titre: "Vente d'une immobilisation",
        image: "venteImmo",
        icon: "picto_tirelire",
        zoneId: 6,
        trueId: 12,
        corrections: [
            {
                ids: [0],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation est intégrée au calcul de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [1],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation est intégrée au calcul de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [2],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation est intégrée au calcul de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [3],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation est intégrée au calcul de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [4],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation est intégrée au calcul de la capacité d'autofinancement. Retentez votre chance !"
            },
            {
                ids: [7],
                autoCorrect: false,
                presque: false,
                texte: "La vente d'une immobilisation n'est pas une charge non décaissée, mais un produit net de cession d'actif. Retentez votre chance ! "
            },
           
        ],
        correct: "La capacité d'autofinancement est égale au résultat net majoré des charges non décaissées moins les produits nets de cessions d'actifs comme la vente d'un immobilisation.",

    },
]

export {
    CartesInfos
}


